import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { ValidationHistoryActions } from './validation-history.actions';
import { ValidationHistoryPartialStoreState } from './validation-history.reducer';
import * as ValidationHistorySelectors from './validation-history.selectors';

@Injectable()
export class ValidationHistoryFacade {
    validations$: Observable<any[]> = this.store.select(ValidationHistorySelectors.getValidations);
    loading$: Observable<boolean> = this.store.select(ValidationHistorySelectors.getLoading);
    startDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getStartDate);
    endDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getEndDate);
    minStartDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getMinStartDate);
    minEndDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getMinEndDate);
    maxStartDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getMaxStartDate);
    maxEndDate$: Observable<Date> = this.store.select(ValidationHistorySelectors.getMaxEndDate);
    diff$: Observable<number> = this.store.select(ValidationHistorySelectors.getDateDiff);

    constructor(
        private store: NgRedux<ValidationHistoryPartialStoreState>,
        private actions: ValidationHistoryActions
    ) {}

    fetchValidationHistory(start: Date, end: Date, token: string) {
        const payload = { start, end, token };

        return this.store.dispatch(this.actions.fetchValidationHistory(payload));
    }

    setStartDate(date: Date) {
        this.store.dispatch(this.actions.setStartDate(date));
    }

    setEndDate(date: Date) {
        this.store.dispatch(this.actions.setEndDate(date));
    }
}
